import Add from '/public/icons/add.svg?react';
import Plus from '/public/icons/plus.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { Button } from '~/shared/ui/Button/Button';

import { FC, useState } from 'react';
import { Portal } from '~/shared/ui/Portal/Portal';
import { AddingAutoForm } from './AddingAutoForm/AddingAutoForm';

interface Props {
  text?: string;
}

export const AddingAuto: FC<Props> = ({ text }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        className={text?.length ? 'w-full' : ''}
        variant={text?.length ? 'noneBg' : 'primary'}
        size={'common'}
        icon={
          !text?.length ? (
            <Plus className={cvaIcon({ iconSize: 'common' })} />
          ) : (
            <Add className={cvaIcon({ iconSize: 'common' })} />
          )
        }
        onlyIcon={!text?.length}>
        {text}
      </Button>{' '}
      {isOpen && (
        <Portal>
          <AddingAutoForm
            open={isOpen}
            type="add"
            onClose={() => setIsOpen(false)}
          />
        </Portal>
      )}
    </>
  );
};
